module.exports = __webpack_public_path__ + "static/media/receiver-img.4683dab9.jpg";